export default __webpack_public_path__ + "static/media/logo-white.bcb07f5f.png";